import React, { useState, useEffect, useCallback } from "react"
import Select from "react-select"
import { Button } from "react-bootstrap"

import { Link as RouterLink, useNavigate, useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import { getDiseasesAction } from "../../../store/actions/DiseasesAction"
import Swal from "sweetalert2"
import { listQuestions } from "../../../services/QuestionsService"
import axiosInstance from "../../../services/AxiosInstance"
import Tooltip from "../Common/Tooltip"
import { handleSuccess, handleError, showErrorAlert } from "../../../services/ErrorHandlingService"
import icon2 from "../../../../src/assets/images/icons8-info-80.png"
import Loader from "../Common/Loader"
import { getInternalType, getQuestionTypeDisplayName } from "../../../utils/questionTypeUtils"
import { JsonRequestError } from "fullcalendar/index.js"
import { FaMicrophone } from "react-icons/fa";
import { useRef } from "react";

const AddForm = () => {
  const { formId } = useParams()
  const [isEditMode, setIsEditMode] = useState(false)
  const [formData, setFormData] = useState({
    formType: "",
    title: "",
    description: "",
    image: null,
    disease_id: "",
    form_for: "",
    karma: "",
    option_form: [],// define for additionalform
  })

  const recognitionRef = useRef(null);
  const [isRecording, setIsRecording] = useState(false);
  const [speechLang, setSpeechLang] = useState("en-IN");
  const toggleLanguage = () => {
    setSpeechLang((prev) => (prev === "en-IN" ? "mr-IN" : "en-IN"));
  };
  
  const [selectedTags, setSelectedTags] = useState([])
  const [newTag, setNewTag] = useState("")
  const [showQuestionDropdown, setShowQuestionDropdown] = useState(false);
  const [showAddButton, setShowAddButton] = useState(true);
  // const [selectedColor, setSelectedColor] = useState("#ff0000");
  const [selectedColor, setSelectedColor] = useState("#f8f9fa");

  const [showModal, setShowModal] = useState(false)
  const [groupName, setGroupName] = useState("")
  const [primaryQuestion, setPrimaryQuestion] = useState(null)
  const [otherQuestions, setOtherQuestions] = useState([])
  // Unified array for all form items (questions and groups)
  const [formItems, setFormItems] = useState([])
  const [collapsed, setCollapsed] = useState({})
  const [collapsedPrimaryQuestions, setCollapsedPrimaryQuestions] = useState({})
  const [collapsedOptions, setCollapsedOptions] = useState({})
  const [collapsedOptionQuestions, setCollapsedOptionQuestions] = useState({})
  const [isToggleOn, setIsToggleOn] = useState(false)
  const [gender, setGender] = useState("")
  const [questionsData, setQuestionsData] = useState([])
  const [loading, setLoading] = useState(true)
  const [submitting, setSubmitting] = useState(false)
  const [availableTags, setAvailableTags] = useState([])
  const [selectedFormId, setSelectedFormId] = useState(null)
  const [isDraftSaved, setIsDraftSaved] = useState(false)
  const [formErrors, setFormErrors] = useState({})
  const [isPublished, setIsPublished] = useState(false)
  const [loadingButton, setLoadingButton] = useState("")
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const diseases = useSelector((state) => state.diseases.diseases || [""])
  const [selectedPrimaryOptions, setSelectedPrimaryOptions] = useState([])
  const [showEligibilityIcon, setShowEligibilityIcon] = useState(false)
  const [showPrimaryOptions, setShowPrimaryOptions] = useState(false)
  const [selectedOptionIds, setSelectedOptionIds] = useState([])
  const [optionQuestionsMap, setOptionQuestionsMap] = useState({})
  const [showOptionQuestionSelector, setShowOptionQuestionSelector] = useState(null)
  const [editingGroupIndex, setEditingGroupIndex] = useState(null)
  const [optionsCollapsed, setOptionsCollapsed] = useState(false)
  const [formName, setFormName] = useState("")
  const [isSubmittingForm, setIsSubmitting] = useState(false)

  const [isLoading, setIsLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedQuestionType, setSelectedQuestionType] = useState("multiple_choice")

  const [options, setOptions] = useState([])
  const [optionForms, setOptionForms] = useState({});

  const startListening = () => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
  
    if (!SpeechRecognition) {
      alert("Speech Recognition not supported");
      return;
    }
  
    if (recognitionRef.current) return;
  
    const recognition = new SpeechRecognition();
    recognitionRef.current = recognition;
  
    recognition.lang = speechLang;
    recognition.continuous = false;
    recognition.interimResults = false;
  
    setIsRecording(true);
  
    recognition.onresult = (event) => {
      const spokenText = event.results[0][0].transcript;
  
      setFormData((prev) => ({
        ...prev,
        description: prev.description
          ? prev.description + " " + spokenText
          : spokenText,
      }));
    };
  
    recognition.onend = () => {
      setIsRecording(false);
      recognitionRef.current = null;
    };
  
    recognition.onerror = () => {
      setIsRecording(false);
      recognitionRef.current = null;
    };
  
    recognition.start();
  };
  
  // Add CSS for proper z-index handling
  useEffect(() => {
    const style = document.createElement("style")
    style.textContent = `
      .modal-backdrop {
        z-index: 9998 !important;
      }
      .modal {
        z-index: 9999 !important;
      }
      .modal-dialog {
        z-index: 10000 !important;
      }
      .modal-content {
        z-index: 10001 !important;
      }
      .modal-footer {
        z-index: 10001 !important;
      }
      .react-select__menu {
        z-index: 999999 !important;
      }
      .react-select__menu-portal {
        z-index: 999999 !important;
      }
      .react-select__menu-list {
        z-index: 999999 !important;
      }
      .react-select__option {
        z-index: 999999 !important;
      }
      .react-select__menu-notice {
        z-index: 999999 !important;
      }
      .react-select__menu-container {
        z-index: 999999 !important;
      }
      .react-select__menu-wrapper {
        z-index: 999999 !important;
      }
      div[class*="react-select__menu"] {
        z-index: 999999 !important;
      }
      div[class*="react-select__option"] {
        z-index: 999999 !important;
      }
      .Select-menu-outer {
        z-index: 999999 !important;
      }
      .Select-menu {
        z-index: 999999 !important;
      }
      .Select-option {
        z-index: 999999 !important;
      }
      /* Target specific option questions Select component */
   
      /* Target all Select components inside modals */
      .modal .react-select__menu,
      .modal .react-select__menu-portal,
      .modal .react-select__menu-list,
      .modal .react-select__option {
        z-index: 999999 !important;
      }
      /* Target Select components by ID pattern */
      [id^="option-questions-"] .react-select__menu,
      [id^="option-questions-"] .react-select__menu-portal,
      [id^="option-questions-"] .react-select__menu-list,
      [id^="option-questions-"] .react-select__option {
        z-index: 999999 !important;
      }
    `
    document.head.appendChild(style)

    return () => {
      document.head.removeChild(style)
    }
  }, [])

  // Helper function to handle both isTab and make_as_tab properties
  const getIsTabValue = (obj) => {
    if (obj && typeof obj === "object") {
      // Check for both isTab and make_as_tab properties
      const isTabValue = obj.isTab !== undefined ? obj.isTab : obj.make_as_tab !== undefined ? obj.make_as_tab : false
      // Convert to boolean - handle both string and boolean values
      if (typeof isTabValue === "string") {
        return isTabValue === "Yes" || isTabValue === "true"
      }
      return Boolean(isTabValue)
    }
    return false
  }

  // This is where filteredTags is defined
  const filteredTags = availableTags.filter(
    (tag) => !selectedTags.some((selectedTag) => selectedTag.value === tag.value),
  )

  // This is where options is defined
  const options1 = [
    { value: "Feedback Form", label: "Feedback Form" },
    { value: "Disease Form", label: "Disease Form" },
    { value: "Campaign Form", label: "Campaign Form" },
    { value: "Interested In", label: "Interested In" },
  ]

  useEffect(() => {
    dispatch(getDiseasesAction(false))
    // Check if we're in edit mode
    if (formId) {
      setIsEditMode(true)
      fetchFormData()
    }
  }, [dispatch, formId])

  // Effect to handle primary question options when editing
  useEffect(() => {
    if (editingGroupIndex !== null && primaryQuestion && selectedPrimaryOptions.length > 0) {
      // Ensure the primary options section is shown when editing
      setShowPrimaryOptions(true)
    }
  }, [editingGroupIndex, primaryQuestion, selectedPrimaryOptions])

  // Effect to restore option questions when editing
  useEffect(() => {
    if (editingGroupIndex !== null && selectedPrimaryOptions.length > 0) {
      // Restore option questions for each option
      selectedPrimaryOptions.forEach((option) => {
        if (option.option_questions && option.option_questions.length > 0) {
          setOptionQuestionsMap((prev) => ({
            ...prev,
            [option.id]: option.option_questions.map((q) => q.label),
          }))
        }
      })
    }
  }, [editingGroupIndex, selectedPrimaryOptions])

  const fetchFormData = useCallback(async () => {
    try {
      setLoading(true)
      const response = await axiosInstance.post("/admin/formDetails", {
        form_id: formId,
      })

      if (response.data.status === "success") {
        const formDetails = response.data.data

        // Set published state
        if (formDetails.form_status === "Published") {
          setIsPublished(true)
        }

        const unifiedFormItems = []

        // -----------------------------
        // 📌 Standalone Questions
        // -----------------------------
        const standaloneQuestions =
          formDetails.questions
            ?.filter((q) => q.isGroup === "No")
            ?.map((q) => ({
              id: q.question_id,
              label: q.question || q.label || "",
              question_type: q.question_type || "short_answer",
              options: q.options || [],
              is_required: q.is_required || "No",
              is_primary: q.is_primary || "No",
              orders: q.orders ? Number(q.orders) : 0,
            })) || []

        standaloneQuestions.forEach((question) => {
          unifiedFormItems.push({
            type: "single",
            content: question,
            orders: question.orders,
          })
        })

        // -----------------------------
        // 📌 Groups (with questions inside)
        // -----------------------------
        const groups =
          formDetails.questions
            ?.filter((q) => q.isGroup === "Yes")
            ?.map((group) => ({
              type: "group",
              bg_color: group.bg_color,
              content: group.questions.map((q) => ({
                id: q.question_id,
                label: q.label,
                question_type: q.question_type,
                options: q.options || [],
                is_required: q.is_required || "No",
                isPrimary: q.is_primary === "Yes",
                orders: q.orders ? Number(q.orders) : 0,
                groupName: group.label,
                isTab: getIsTabValue(group),
                bg_color: group.bg_color,
              })),
              groupName: group.label,
              isTab: getIsTabValue(group),
              orders: group.orders ? Number(group.orders) : 0, // ✅ use group's order
            })) || []

        groups.forEach((group) => {
          unifiedFormItems.push(group)
        })
        console.log("<=================================>", groups)
        // -----------------------------
        // 📌 Set meta data
        // -----------------------------
        setFormData((prev) => ({
          ...prev,
          formType: formDetails.form_type || "",
          title: formDetails.form_title || "",
          description: formDetails.form_description || "",
          disease_id: formDetails.disease_id || "",
          form_for: formDetails.form_for,
        }))

        setGender(formDetails.gender || "")

        if (formDetails.tags) {
          try {
            setSelectedTags(
              formDetails.tags.map((tag) => ({
                value: tag.tag_id,
                label: tag.tag_name,
              })),
            )
          } catch (err) {
            console.warn("Error parsing tags:", err)
          }
        }

        // -----------------------------
        // 📌 Option Questions Map (for primary questions inside groups)
        // -----------------------------
        const initialOptionQuestionsMap = {}
        formDetails.questions?.forEach((q) => {
          if (q.isGroup === "Yes") {
            q.questions.forEach((groupQ) => {
              if (groupQ.is_primary === "Yes" && groupQ.options) {
                groupQ.options.forEach((option) => {
                  if (option.option_questions && option.option_questions.length > 0) {
                    initialOptionQuestionsMap[option.option_id] = option.option_questions.map((subQ) => subQ.label)
                  }
                })
              }
            })
          }
        })
        setOptionQuestionsMap((prev) => ({ ...prev, ...initialOptionQuestionsMap }))
        console.log("<==========option quentions==================>", initialOptionQuestionsMap)
        // -----------------------------
        // 📌 Sort & Finalize
        // -----------------------------
        unifiedFormItems.sort((a, b) => (a.orders || 0) - (b.orders || 0))
        setFormItems(unifiedFormItems)
        console.log("<==============unified items=======================>", unifiedFormItems)
        // Optional success message
        // // handleSuccess("Form data loaded successfully")
        // -----------------------------

      }
    } catch (err) {
      handleError(err, "Error loading form data")
    } finally {
      setLoading(false)
    }
  }, [formId])

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        setLoading(true)
        const loginDetails = JSON.parse(localStorage.getItem("loginDetails"))
        const admin_id = loginDetails?.id || 1
        const res = await listQuestions({ admin_id })
        if (res.data.status === "success") {
          const questions = res.data.data.map((q) => ({
            value: q.question_id,
            label: q.question || q.label || "",
            raw: {
              ...q,
              question_type: getInternalType(q.question_type) || "short_answer",
            },
          }))
          setQuestionsData(questions)
        }
      } catch (err) {
        showErrorAlert("Failed to load questions")
      } finally {
        setLoading(false)
      }
    }
    fetchQuestions()
  }, [])

  // Fetch tag list dynamically
  useEffect(() => {
    const fetchTags = async () => {
      try {
        const res = await axiosInstance.post("/admin/tagList")
        if (res.data.status === "success") {
          setAvailableTags(
            res.data.data.map((tag) => ({
              value: tag.tag_id,
              label: tag.tag_name,
            })),
          )
        }
      } catch {
        showErrorAlert("Failed to load tags")
      }
    }
    fetchTags()
  }, [])

  // Effect to restore primary question states when form data is loaded
  useEffect(() => {
    if (formItems.length > 0 && questionsData.length > 0) {
      // Restore primary question collapse states
      const primaryQuestionStates = {}
      const optionStates = {}
      const optionQuestionStates = {}

      formItems.forEach((item, itemIndex) => {
        if (item.type === "group" && item.content && Array.isArray(item.content)) {
          // Handle group items
          item.content.forEach((questionObj) => {
            const questionLabel = typeof questionObj === "string" ? questionObj : questionObj.label
            const questionData = questionsData.find((q) => q.label === questionLabel)?.raw
            const isPrimary = typeof questionObj === "object" && questionObj.isPrimary

            if (isPrimary && questionData?.options) {
              const questionId = questionObj.id || questionLabel
              primaryQuestionStates[questionId] = collapsedPrimaryQuestions[questionId] || false

              // Restore option collapse states
              questionData.options.forEach((option) => {
                const optionId = option.id || option.option_id
                optionStates[optionId] = collapsedOptions[optionId] || false

                // Restore option question collapse states
                if (option.option_questions) {
                  option.option_questions.forEach((subQuestion, subIndex) => {
                    const optionQuestionId = `${optionId}-${subQuestion.id || subIndex}`
                    optionQuestionStates[optionQuestionId] = collapsedOptionQuestions[optionQuestionId] || false
                  })
                }
              })
            }
          })
        }
        // Note: Single questions don't have primary question states to restore
      })

      // Update collapse states
      if (Object.keys(primaryQuestionStates).length > 0) {
        setCollapsedPrimaryQuestions((prev) => ({ ...prev, ...primaryQuestionStates }))
      }
      if (Object.keys(optionStates).length > 0) {
        setCollapsedOptions((prev) => ({ ...prev, ...optionStates }))
      }
      if (Object.keys(optionQuestionStates).length > 0) {
        setCollapsedOptionQuestions((prev) => ({ ...prev, ...optionQuestionStates }))
      }
    }
  }, [formItems, questionsData])

  const toggleCollapse = (index) => {
    setCollapsed((prevState) => ({
      ...prevState,
      [index]: !prevState[index], // Toggle collapse for each group
    }))
  }

  const togglePrimaryQuestionCollapse = (questionId) => {
    setCollapsedPrimaryQuestions((prevState) => ({
      ...prevState,
      [questionId]: !prevState[questionId],
    }))
  }

  const toggleOptionCollapse = (optionId) => {
    setCollapsedOptions((prevState) => ({
      ...prevState,
      [optionId]: !prevState[optionId],
    }))
  }

  const toggleOptionQuestionsCollapse = (optionId) => {
    setCollapsedOptionQuestions((prevState) => ({
      ...prevState,
      [optionId]: !prevState[optionId],
    }))
  }

  const toggleOptionsCollapse = () => {
    setOptionsCollapsed(!optionsCollapsed)
  }

  const toggleModalOptionCollapse = (optionId) => {
    setCollapsedOptions((prev) => ({
      ...prev,
      [optionId]: !prev[optionId],
    }))
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      setFormData((prev) => ({ ...prev, image: URL.createObjectURL(file) }))
    }
  }

  const handleTypeChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      formType: selectedOption.value,
      disease_id: "", // Changed from diseaseType to disease_id
      //form_for: selectedOption.value,
    }))
    // Clear formItems when form type changes
    setFormItems([])
    setShowAddButton(false)
    setShowQuestionDropdown(true)
  }

  const handleDiseaseChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      disease_id: selectedOption ? selectedOption.value : "",
    }))
    if (selectedOption && selectedOption.value) {
      setFormErrors((prev) => ({
        ...prev,
        disease_id: undefined,
      }))
    }
  }

  const handleQuestionChange = (selectedOption) => {
    if (selectedOption) {
      const questionData = questionsData.find((q) => q.label === selectedOption.label)?.raw
      if (questionData) {
        // Check if question already exists in formItems
        const questionExists = formItems.some(
          (item) => item.type === "single" && item.content.label === selectedOption.label,
        )

        if (!questionExists) {
          // Create full question object
          const question = {
            id: questionData.question_id,
            label: questionData.question || selectedOption.label,
            question_type: questionData.question_type,
            options: questionData.options || [],
            is_required: questionData.is_required || "No",
            is_primary: questionData.is_primary || "No",
            orders: questionData.orders || 0,
          }

          // Add to unified formItems array
          setFormItems((prev) => {
            const newFormItems = [
              ...prev,
              {
                type: "single",
                content: question,
                orders: question.orders || 0,
              },
            ]
            return newFormItems
          })

          // Clear questions error if at least one question exists
          if (formItems.length > 0 || true) {
            setFormErrors((prev) => ({ ...prev, questions: undefined }))
          }

          setShowAddButton(true)
          setShowQuestionDropdown(false)
        }
      }
    }
  }

  const handleDeleteQuestion = (question) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You won't be able to revert this!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        if (Array.isArray(question)) {
          // It's a group - find and remove from formItems
          setFormItems((prev) => prev.filter((item) => !(item.type === "group" && item.content === question)))
        } else {
          // It's a single question - find and remove from formItems
          setFormItems((prev) => prev.filter((item) => !(item.type === "single" && item.content.label === question)))
        }
        setShowQuestionDropdown(true)
        Swal.fire("Deleted!", "Your question has been deleted.", "success")
      }
    })
  }

  const saveOrderChanges = async (updatedFormItems) => {
    try {
      if (!isEditMode) return // Only save order changes in edit mode

      const formIdToUse = formId || selectedFormId
      if (!formIdToUse) return

      const labelsInGroups = new Set()
      const processedGroups = new Map() // Track processed groups to prevent duplicates

      updatedFormItems.forEach((item) => {
        if (item.type === "group" && Array.isArray(item.content)) {
          item.content.forEach((q) => {
            const label = typeof q === "string" ? (q || "").trim() : (q.label || "").trim()
            if (label) labelsInGroups.add(label)
          })
        }
      })

      const question_groups = []
      const processedGroupIds = new Set() // Track group IDs to prevent duplicates

      updatedFormItems.forEach((item, index) => {
        if (item.type === "single") {
          const singleLabel = (item.content?.label || item.content?.question || "").trim()
          if (!singleLabel || labelsInGroups.has(singleLabel)) return

          const questionData = questionsData.find((q) => (q.label || q.question || "").trim() === singleLabel)?.raw
          if (questionData) {
            question_groups.push({
              id: questionData.question_id,
              label: singleLabel,
              type: getInternalType(questionData.question_type) || "short_answer",
              isGroup: "No",
              order: index + 1,
              isRequired: questionData.is_required === "Yes",
              isImportant: questionData.is_important === "Yes",
              options: questionData.options || [],
            })
          }
        } else if (item.type === "group") {
          if (item.content && Array.isArray(item.content) && item.content.length > 0) {
            const groupName = item.content[0]?.groupName || `Group ${index + 1}`
            const existingGroupId = item.content[0]?.groupId || `g${index + 1}`

            // Skip if this group ID has already been processed
            if (processedGroupIds.has(existingGroupId)) return
            processedGroupIds.add(existingGroupId)

            const seen = new Set()
            const uniqueContent = item.content.filter((questionObj) => {
              const label = (typeof questionObj === "string" ? questionObj : questionObj.label || "").trim()
              if (!label) return false
              if (seen.has(label)) return false
              seen.add(label)
              return true
            })

            const groupQuestions = uniqueContent.map((questionObj, questionIndex) => {
              const questionLabel = (typeof questionObj === "string" ? questionObj : questionObj.label || "").trim()
              const questionData = questionsData.find(
                (q) => (q.label || q.question || "").trim() === questionLabel,
              )?.raw

              const isPrimary =
                (typeof questionObj.isPrimary === "boolean" && questionObj.isPrimary) ||
                questionObj.is_primary === "Yes"

              let processedOptions = []

              if (
                isPrimary &&
                questionObj.options &&
                Array.isArray(questionObj.options) &&
                questionObj.options.length > 0
              ) {
                // Preserve existing options structure with option_questions
                processedOptions = questionObj.options.map((option) => {
                  const baseOption = {
                    id: option.id || option.option_id?.toString() || "",
                    label: option.label || option.option_name || "",
                  }

                  // Preserve option_questions if they exist
                  if (option.option_questions && Array.isArray(option.option_questions)) {
                    baseOption.option_questions = option.option_questions
                  }

                  return baseOption
                })
              } else if (questionData?.options) {
                processedOptions = questionData.options.map((option) => ({
                  id: option.option_id?.toString?.() || String(option.id || ""),
                  label: option.option_name || option.label || "",
                  // Preserve option_questions if they exist in original data
                  ...(option.option_questions && { option_questions: option.option_questions }),
                }))
              }

              return {
                id: questionData?.question_id?.toString(),
                label: questionLabel,
                type: getInternalType(questionData?.question_type) || "short_answer",
                order: questionIndex + 1,
                isRequired: questionData?.is_required === "Yes",
                isImportant: questionData?.is_important === "Yes",
                is_primary: isPrimary ? "Yes" : "No",
                options: processedOptions.length > 0 ? processedOptions : questionData?.options || [],
              }
            })

            question_groups.push({
              id: existingGroupId,
              label: groupName,
              isGroup: "Yes",
              isTab: uniqueContent[0]?.isTab || false,
              bg_color: uniqueContent[0]?.bg_color || "#ffffff",
              order: index + 1,
              questions: groupQuestions,
            })
          }
        }
      })

      const payload = {
        form_id: formIdToUse,
        form_title: formData.title,
        form_description: formData.description,
        form_type: formData.formType,
        disease_id: formData.disease_id,
        gender: gender,
        form_status: status,
        tags: JSON.stringify(selectedTags.map((tag) => tag.value)),
        question_groups: JSON.stringify(question_groups),
        form_for: formData.form_for,
      }

      await axiosInstance.post("/admin/editForm", payload)
    } catch (error) {
      console.error("Error saving order changes:", error)
    }
  }

  const handleDrop = async (sourceIndex, targetIndex) => {
    try {
      if (sourceIndex === targetIndex) return

      // Simple reordering: Just reorder the formItems array directly
      setFormItems((prev) => {
        const newFormItems = [...prev]
        const [movedItem] = newFormItems.splice(sourceIndex, 1)
        newFormItems.splice(targetIndex, 0, movedItem)

        // Update orders to maintain sequence
        newFormItems.forEach((item, index) => {
          if (item.content && typeof item.content === "object") {
            if (Array.isArray(item.content)) {
              // It's a group
              item.content.forEach((q) => {
                if (q && typeof q === "object") {
                  q.orders = index
                }
              })
            } else {
              // It's a single question
              item.content.orders = index
            }
          }
          item.orders = index
        })

        // saveOrderChanges(newFormItems)

        return newFormItems
      })
    } catch (error) {
      console.error("Error handling drop:", error)
    }
  }

  // HTML5 Drag and Drop handlers
  const handleDragStart = (e, itemType, itemIndex, groupIndex = null) => {
    const dragData = {
      type: itemType,
      index: itemIndex,
      groupIndex: groupIndex,
    }

    e.dataTransfer.setData("text/plain", JSON.stringify(dragData))
    e.dataTransfer.effectAllowed = "move"
  }

  const handleDragOver = (e) => {
    e.preventDefault()
    e.dataTransfer.dropEffect = "move"

    // Add visual feedback
    const targetRow = e.currentTarget.closest("tr")
    if (targetRow) {
      targetRow.style.backgroundColor = "#e3f2fd"
      targetRow.style.borderTop = "2px solid #2196f3"
    }
  }

  const handleDragLeave = (e) => {
    // Remove visual feedback when leaving drop zone
    const targetRow = e.currentTarget.closest("tr")
    if (targetRow) {
      targetRow.style.backgroundColor = ""
      targetRow.style.borderTop = ""
    }
  }

  const handleDropOriginal = (e, targetType, targetIndex, targetGroupIndex = null) => {
    e.preventDefault()

    // Remove visual feedback
    const targetRow = e.currentTarget.closest("tr")
    if (targetRow) {
      targetRow.style.backgroundColor = ""
      targetRow.style.borderTop = ""
    }

    try {
      const dragData = JSON.parse(e.dataTransfer.getData("text/plain"))
      const { type: sourceType, index: sourceIndex, groupIndex: sourceGroupIndex } = dragData

      // Prevent dropping on itself
      if (sourceType === targetType && sourceIndex === targetIndex && sourceGroupIndex === targetGroupIndex) {
        return
      }

      handleDrop(sourceIndex, targetIndex)
    } catch (error) {
      console.error("Error handling drop:", error)
    }
  }

  // HTML5 Drag and Drop for modal questions
  const handleModalDragStart = (e, questionIndex) => {
    e.dataTransfer.setData(
      "text/plain",
      JSON.stringify({
        type: "modalQuestion",
        index: questionIndex,
      }),
    )
    e.dataTransfer.effectAllowed = "move"
  }

  const handleModalDrop = (e, targetIndex) => {
    e.preventDefault()

    try {
      const dragData = JSON.parse(e.dataTransfer.getData("text/plain"))
      const { type: sourceType, index: sourceIndex } = dragData

      if (sourceType === "modalQuestion" && sourceIndex !== targetIndex) {
        const newOtherQuestions = [...otherQuestions]
        const [removed] = newOtherQuestions.splice(sourceIndex, 1)
        newOtherQuestions.splice(targetIndex, 0, removed)
        setOtherQuestions(newOtherQuestions)
      }
    } catch (error) {
      // Error handling for modal drop
    }
  }

  // HTML5 Drag and Drop for option questions
  const handleOptionQuestionDragStart = (e, optionId, questionIndex) => {
    e.dataTransfer.setData(
      "text/plain",
      JSON.stringify({
        type: "optionQuestion",
        optionId: optionId,
        index: questionIndex,
      }),
    )
    e.dataTransfer.effectAllowed = "move"
  }

  const handleOptionQuestionDrop = (e, optionId, targetIndex) => {
    e.preventDefault()

    try {
      const dragData = JSON.parse(e.dataTransfer.getData("text/plain"))
      const { type: sourceType, optionId: sourceOptionId, index: sourceIndex } = dragData

      if (sourceType === "optionQuestion" && sourceOptionId === optionId && sourceIndex !== targetIndex) {
        setOptionQuestionsMap((prev) => {
          const currentQuestions = [...(prev[optionId] || [])]
          const [removed] = currentQuestions.splice(sourceIndex, 1)
          currentQuestions.splice(targetIndex, 0, removed)
          return {
            ...prev,
            [optionId]: currentQuestions,
          }
        })
      }
    } catch (error) {
      // Error handling for option question drop
    }
  }

  const handleAddGroup = () => {
    setShowModal(true)
    setEditingGroupIndex(null)
    setGroupName("")
    setPrimaryQuestion(null)
    setOtherQuestions([])
    setSelectedPrimaryOptions([])
    setOptionQuestionsMap({})
    setIsToggleOn(false)
    setOptionsCollapsed(false)
    setCollapsedOptions({})
    setShowPrimaryOptions(false)
  }

  const handleSelectChange = (selectedOptions) => {
    if (selectedOptions) {
      // Handle both single and multi-select
      const optionsArray = Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions]
      // Filter out duplicates
      const newTags = optionsArray.filter(
        (option) => !selectedTags.some((selectedTag) => selectedTag.value.toLowerCase() === option.value.toLowerCase()),
      )
      setSelectedTags([...selectedTags, ...newTags])
      setNewTag("")
    }
  }

  const handleAddTag = () => {
    const trimmedTag = newTag.trim()
    if (trimmedTag && !selectedTags.some((tag) => tag.label.toLowerCase() === trimmedTag.toLowerCase())) {
      // If tag is not in availableTags, add as custom
      let tagObj = availableTags.find((tag) => tag.label.toLowerCase() === trimmedTag.toLowerCase())
      if (!tagObj) {
        tagObj = { value: trimmedTag, label: trimmedTag }
      }
      setSelectedTags([...selectedTags, tagObj])
      setNewTag("")
    }
  }

  const handleRemoveTag = (tagToRemove) => {
    setSelectedTags(selectedTags.filter((tag) => tag.value !== tagToRemove.value))
  }

  const handlePreview = async () => {
    try {
      setSubmitting(true)
      // Determine which form_id to use
      let formIdToUse = null
      if (isEditMode) {
        // If we're in edit mode, try to use formId from URL first, then fallback to selectedFormId
        formIdToUse = formId || selectedFormId
      } else {
        // If not in edit mode, use selectedFormId
        formIdToUse = selectedFormId
      }

      if (formIdToUse) {
        const encodedFormId = btoa(formIdToUse)
        window.open(`/forms/patient-form/${encodedFormId}`, "_blank")
      } else {
        if (!isDraftSaved) {
          showErrorAlert("Please save the form as draft first to preview")
          return
        }
      }
    } catch (error) {
      handleError(error, "Failed to preview form")
    } finally {
      setSubmitting(false)
    }
  }

  const handleDraftOrPublish = async (status) => {
    try {
      setSubmitting(true)
      setLoadingButton(status)

      const errors = validateForm(formData)
      if (Object.keys(errors).length > 0) {
        setFormErrors(errors)
        showErrorAlert("Please fill in all required fields")
        return
      }

      // Build set of all labels that are inside groups
      const labelsInGroups = new Set()
      formItems.forEach((item) => {
        if (item.type === "group" && Array.isArray(item.content)) {
          item.content.forEach((q) => {
            const lbl = typeof q === "string" ? q?.trim() : (q?.label || "").trim()
            if (lbl) labelsInGroups.add(lbl)
          })
        }
      })

      const question_groups = []

      formItems.forEach((item, index) => {
        if (item.type === "single") {
          const singleLabel = (item.content?.label || "").trim()
          // Skip if this single is already part of a group
          if (!singleLabel || labelsInGroups.has(singleLabel)) return

          const questionData = questionsData.find((q) => (q.label || "").trim() === singleLabel)?.raw
          if (questionData) {
            question_groups.push({
              id: questionData.question_id,
              label: singleLabel,
              type: getInternalType(questionData.question_type) || "short_answer",
              isGroup: "No",
              order: index + 1,
              isRequired: questionData.is_required === "Yes",
              isImportant: questionData.is_important === "Yes",
              options: questionData.options || [],
            })
          }
        } else if (item.type === "group") {
          if (item.content && Array.isArray(item.content) && item.content.length > 0) {
            // Deduplicate group content by label while preserving order
            const seen = new Set()
            const uniqueContent = item.content.filter((q) => {
              const lbl = typeof q === "string" ? q?.trim() : (q?.label || "").trim()
              if (!lbl) return false
              if (seen.has(lbl)) return false
              seen.add(lbl)
              return true
            })

            const groupQuestions = uniqueContent.map((questionObj, questionIndex) => {
              const questionLabel = typeof questionObj === "string" ? questionObj : questionObj.label
              const questionData = questionsData.find((q) => q.label === questionLabel)?.raw

              const isPrimary =
                (typeof questionObj.isPrimary === "boolean" && questionObj.isPrimary) ||
                questionObj.is_primary === "Yes"

              let processedOptions = []
              if (isPrimary && questionObj.options && questionObj.options.length > 0) {
                processedOptions = questionObj.options
              } else if (questionData?.options) {
                processedOptions = questionData.options.map((option) => ({
                  id: option.option_id.toString(),
                  label: option.option_name,
                }))
              }



              console.log("<=========================Sub quentions=============================>", JSON.stringify(processedOptions))
              return {
                id: questionData?.question_id?.toString(),
                label: questionLabel,
                type: getInternalType(questionData?.question_type) || "short_answer",
                order: questionIndex + 1,
                isRequired: questionData?.is_required === "Yes",
                isImportant: questionData?.is_important === "Yes",
                is_primary: isPrimary ? "Yes" : "No",
                options: processedOptions.length > 0 ? processedOptions : questionData?.options || [],
              }
            })

            question_groups.push({
              id: `g${index + 1}`,
              label: uniqueContent[0]?.groupName || `Group ${index + 1}`,
              isGroup: "Yes",
              isTab: uniqueContent[0]?.isTab || false,
              bg_color: uniqueContent[0]?.bg_color || "#ffffff", // ✅ ADD
              order: index + 1,
              questions: groupQuestions,
            })
          }
        }
      })


      const payload = {
        form_title: formData.title,
        form_description: formData.description,
        form_type: formData.formType,
        disease_id: formData.disease_id,
        gender: gender,
        form_status: status,
        tags: JSON.stringify(selectedTags.map((tag) => tag.value)),
        question_groups: JSON.stringify(question_groups),
        form_for: formData.form_for,
      }
      console.log("update form==========================================>", JSON.stringify(question_groups))
      // return

      let response
      if (isEditMode || selectedFormId) {
        payload.form_id = selectedFormId ? selectedFormId : formId
        response = await axiosInstance.post("/admin/editForm", payload)
      } else {
        response = await axiosInstance.post("/admin/addForm", payload)
      }

      if (response.data.status === "success") {
        const message =
          isEditMode || selectedFormId
            ? isPublished
              ? "Published form updated successfully!"
              : "Form updated successfully!"
            : "Form created successfully!"
        handleSuccess(message)

        if (!isEditMode && !selectedFormId) {
          setIsDraftSaved(true)
          if (response.data.data?.form_id) {
            const newFormId = response.data.data.form_id
            setSelectedFormId(newFormId)
            setIsEditMode(true)
          }
        }
      }
    } catch (err) {
      handleError(err, isEditMode || selectedFormId ? "Error updating form" : "Error creating form")
    } finally {
      setSubmitting(false)
      setLoadingButton("")
    }
  }

  const handlePublishForm = async () => {
    try {
      setSubmitting(true)
      setLoadingButton("published")

      // Determine which form_id to use
      let formIdToUse = null
      if (isEditMode) {
        // If we're in edit mode, try to use formId from URL first, then fallback to selectedFormId
        formIdToUse = formId || selectedFormId
      } else {
        // If not in edit mode, use selectedFormId
        formIdToUse = selectedFormId
      }

      const payload = {
        form_id: formIdToUse,
      }

      // Ensure we have a valid form_id
      if (!payload.form_id) {
        throw new Error("Form ID not found. Please save the form as draft first.")
      }

      const response = await axiosInstance.post("/admin/formPublished", payload)

      if (response.data.status === "success") {
        handleSuccess("Form published successfully!")
        setIsPublished(true)
        // KEEP NAVIGATION - User should navigate after publish/republish
        navigate("/forms")
      } else {
        throw new Error(response.data.message || "Failed to publish form")
      }
    } catch (err) {
      handleError(err, "Error publishing form")
    } finally {
      setSubmitting(false)
      setLoadingButton("")
    }
  }

  const validateForm = (formData) => {
    const errors = {}

    // Basic field validation
    if (!formData.title?.trim()) {
      errors.title = "Title is required"
    }
    if (!formData.description?.trim()) {
      errors.description = "Description is required"
    }
    if (!gender) {
      errors.gender = "Gender is required"
    }

    // Check if at least one question or group exists
    if (formItems.length === 0) {
      errors.questions = "At least one question or group is required"
    }

    // Disease type validation for disease forms
    if (formData.formType === "disease" && !formData.disease_id) {
      errors.diseaseType = "Please select a disease type"
    }

    // Group validation - check each group has questions
    formItems.forEach((item, idx) => {
      if (item.type === "group") {
        if (!item.content || !Array.isArray(item.content) || item.content.length === 0) {
          errors[`group_${idx}`] = "Group cannot be empty"
        }
      }
    })

    return errors
  }

  // const handleEditGroup = (groupIndex) => {
  //   const groupItem = formItems[groupIndex]

  //   if (
  //     groupItem &&
  //     groupItem.type === "group" &&
  //     groupItem.content &&
  //     Array.isArray(groupItem.content) &&
  //     groupItem.content.length > 0
  //   ) {
  //     // Extract group data for editing
  //     const group = groupItem.content
  //     const groupName = group[0]?.groupName || `Group ${groupIndex + 1}`

  //     // Find the primary question - it should be the one with isPrimary: true
  //     const primaryQuestion = group.find((q) => q.isPrimary === true) || null
  //     const otherQuestions = group.filter((q) => !q.isPrimary).map((q) => q.label)

  //     let selectedPrimaryOptions = []
  //     const optionQuestionsMap = {}

  //     if (primaryQuestion && primaryQuestion.options) {
  //       // Check if this is a locally created group (has formatted options) or saved group
  //       const isLocallyCreated =
  //         primaryQuestion.options.length > 0 &&
  //         primaryQuestion.options[0].hasOwnProperty("id") &&
  //         primaryQuestion.options[0].hasOwnProperty("label")

  //       if (isLocallyCreated) {
  //         // This is a locally created group with formatted options
  //         selectedPrimaryOptions = primaryQuestion.options.map((opt) => ({
  //           option_id: opt.id,
  //           id: opt.id,
  //           option_name: opt.label,
  //           label: opt.label,
  //           name: opt.label,
  //           option_questions: opt.option_questions || [],
  //         }))

  //         // Extract option questions map from the formatted options
  //         primaryQuestion.options.forEach((option) => {
  //           if (option.option_questions && option.option_questions.length > 0) {
  //             optionQuestionsMap[option.id] = option.option_questions.map((q) => q.label || q.question)
  //           }
  //         })
  //       } else {
  //         // This is a saved group with raw options from the database
  //         selectedPrimaryOptions = primaryQuestion.options.map((opt) => ({
  //           option_id: opt.option_id || opt.id,
  //           id: opt.option_id || opt.id,
  //           option_name: opt.option_name || opt.label,
  //           label: opt.option_name || opt.label,
  //           name: opt.option_name || opt.label,
  //           option_questions: opt.option_questions || [],
  //         }))

  //         // Extract option questions map from the raw options
  //         primaryQuestion.options.forEach((option) => {
  //           const optionId = (option.option_id || option.id).toString()
  //           if (option.option_questions && option.option_questions.length > 0) {
  //             optionQuestionsMap[optionId] = option.option_questions.map((q) => q.question || q.label)
  //           }
  //         })
  //       }
  //     }

  //     // Set the form data for editing
  //     setGroupName(groupName)
  //     setPrimaryQuestion(primaryQuestion ? { label: primaryQuestion.label } : null)
  //     setOtherQuestions(otherQuestions)
  //     setSelectedPrimaryOptions(selectedPrimaryOptions)
  //     setOptionQuestionsMap(optionQuestionsMap)
  //     setIsToggleOn(getIsTabValue(group[0]) || false)

  //     setEditingGroupIndex(groupIndex)
  //     setShowModal(true)

  //     if (selectedPrimaryOptions.length > 0) {
  //       setShowPrimaryOptions(true)
  //       setOptionsCollapsed(false)
  //     }
  //   }
  // }
  const handleEditGroup = (groupIndex) => {
    const groupItem = formItems[groupIndex]

    if (
      groupItem &&
      groupItem.type === "group" &&
      groupItem.content &&
      Array.isArray(groupItem.content) &&
      groupItem.content.length > 0
    ) {
      // Extract group data for editing
      const group = groupItem.content
      const groupName = group[0]?.groupName || `Group ${groupIndex + 1}`

      // Find the primary question - it should be the one with isPrimary: true
      // const primaryQuestion = group.find((q) => q.isPrimary === true) || null

      // const otherQuestions = group.filter((q) => !q.isPrimary).map((q) => q.label)
      // ✅ Detect primary question
      const primaryQuestion =
        group.find((q) => q.isPrimary === true || q.is_primary === "Yes") || null;

      // ✅ Include ALL questions, even primary
      const otherQuestions = group.map((q) => q.label || q.question);

      let selectedPrimaryOptions = []
      const optionQuestionsMap = {}

      if (primaryQuestion && primaryQuestion.options) {
        const isLocallyCreated =
          primaryQuestion.options.length > 0 &&
          primaryQuestion.options[0].hasOwnProperty("id") &&
          primaryQuestion.options[0].hasOwnProperty("label")

        if (isLocallyCreated) {
          // Locally created group
          selectedPrimaryOptions = primaryQuestion.options.map((opt) => ({
            option_id: opt.id,
            id: opt.id,
            option_name: opt.label,
            label: opt.label,
            name: opt.label,
            option_questions: opt.option_questions || [],
          }))

          primaryQuestion.options.forEach((option) => {
            if (option.option_questions && option.option_questions.length > 0) {
              optionQuestionsMap[option.id] = option.option_questions.map((q) => q.label || q.question)
            }
          })
        } else {
          // Saved group with raw options
          selectedPrimaryOptions = primaryQuestion.options.map((opt) => {
            const normalizedOpt = {
              option_id: opt.option_id || opt.id,
              id: opt.option_id || opt.id,
              option_name: opt.option_name || opt.label,
              label: opt.option_name || opt.label,
              name: opt.option_name || opt.label,
              option_questions: opt.option_questions || [],
            }

            // ✅ Restore option_forms here
            if (opt.option_forms) {
              const activeForms = Object.entries(opt.option_forms)
                .filter(([_, value]) => value === "Yes")
                .map(([key]) => key.toUpperCase())

              setOptionForms((prev) => ({
                ...prev,
                [normalizedOpt.id]: activeForms, // e.g. ["MENOPAUSE", "MALE"]
              }))
            }

            return normalizedOpt
          })

          primaryQuestion.options.forEach((option) => {
            const optionId = (option.option_id || option.id).toString()
            if (option.option_questions && option.option_questions.length > 0) {
              optionQuestionsMap[optionId] = option.option_questions.map((q) => q.question || q.label)
            }
          })
        }
      }

      // Set the form data for editing
      setGroupName(groupName)
      setSelectedColor(group[0]?.bg_color || "#ff0000");
      setPrimaryQuestion(primaryQuestion ? { label: primaryQuestion.label } : null)
      setOtherQuestions(otherQuestions)
      setSelectedPrimaryOptions(selectedPrimaryOptions)
      setOptionQuestionsMap(optionQuestionsMap)
      setIsToggleOn(getIsTabValue(group[0]) || false)

      setEditingGroupIndex(groupIndex)
      setShowModal(true)

      if (selectedPrimaryOptions.length > 0) {
        setShowPrimaryOptions(true)
        setOptionsCollapsed(false)
      }
    }
  }


  const handleUpdateGroup = (e) => {
    e.preventDefault()

    if (!groupName.trim()) {
      alert("Please enter a group name")
      return
    }

    if (!primaryQuestion) {
      alert("Please select a primary question")
      return
    }

    const primaryRaw = questionsData.find((q) => q.label === primaryQuestion.label)?.raw

    const formattedOptions = selectedPrimaryOptions.map((opt) => {
      // Try multiple possible option ID fields with consistent string conversion
      const optionId = (opt.option_id || opt.id || opt.optionId || "").toString()
      const optionObj = {
        id: optionId,
        label: opt.option_name || opt.label || opt.name,
      }

      const subQuestions =
        optionQuestionsMap[optionId] ||
        optionQuestionsMap[opt.option_id?.toString()] ||
        optionQuestionsMap[opt.id?.toString()] ||
        optionQuestionsMap[opt.optionId?.toString()] ||
        []

      if (subQuestions.length > 0) {
        optionObj.option_questions = subQuestions.map((qLabel, idx) => {
          const raw = questionsData.find((q) => q.label === qLabel)?.raw
          return {
            id: raw?.question_id?.toString() || `q_${Date.now()}_${idx}`,
            label: raw?.question || qLabel,
            type: getInternalType(raw?.question_type) || "short_answer",
            order: idx + 1,
            isRequired: raw?.is_required === "Yes",
            isImportant: raw?.is_important === "Yes",
            is_primary: "Yes",
          }
        })
        optionObj.option_form = allForms.reduce((acc, val) => {
          acc[val] = (optionForms?.[optionId] || [])
            .map((v) => v.toUpperCase())
            .includes(val)
            ? "Yes"
            : "No";
          return acc;
        }, {});
        console.log("<================= handleupdtagroup =================>", optionId, optionForms?.[optionId], optionObj.option_form);
        // define for addtionalform
      }
      return optionObj
    })

    // Combine primary and other questions, ensuring no duplicates
    const filteredOtherQuestions = otherQuestions.filter((q) => q !== primaryQuestion.label)
    const updatedQuestions = [...(primaryQuestion ? [primaryQuestion.label] : []), ...filteredOtherQuestions]

    // Remove duplicates from the questions array
    const seen = new Set()
    const uniqueQuestions = updatedQuestions.filter((lbl) => {
      const trimmedLabel = lbl?.trim()
      if (!trimmedLabel || seen.has(trimmedLabel)) return false
      seen.add(trimmedLabel)
      return true
    })

    const groupStructure = uniqueQuestions.map((questionLabel, idx) => {
      if (questionLabel === primaryQuestion.label) {
        return {
          label: questionLabel,
          groupName: groupName,
          isPrimary: true,
          options: formattedOptions,
          isTab: isToggleOn,
          bg_color: selectedColor,
          sequence: idx + 1,
          groupId: formItems[editingGroupIndex]?.content?.[0]?.groupId || `g${editingGroupIndex + 1}`,
        }
      }
      return {
        label: questionLabel,
        groupName: groupName,
        isPrimary: false,
        isTab: isToggleOn,
        bg_color: selectedColor, 
        sequence: idx + 1,
        groupId: formItems[editingGroupIndex]?.content?.[0]?.groupId || `g${editingGroupIndex + 1}`,
      }
    })

    // Update the specific group at editingGroupIndex without creating duplicates
    setFormItems((prev) => {
      const newFormItems = [...prev]

      // Replace the group at the specific index
      newFormItems[editingGroupIndex] = {
        type: "group",
        content: groupStructure,
        orders: editingGroupIndex,
      }

      const labelsInUpdatedGroup = new Set(groupStructure.map((q) => q.label?.trim()).filter(Boolean))

      // Enhanced filtering to prevent duplicates while preserving other groups
      const filteredItems = newFormItems.filter((item, idx) => {
        if (idx === editingGroupIndex) return true // Keep the updated group

        if (item.type === "single") {
          const label = (item.content?.label || item.content?.question || "").trim()
          return !labelsInUpdatedGroup.has(label) // Remove if it's now part of the updated group
        }

        if (item.type === "group" && idx !== editingGroupIndex) {
          // For other groups, filter out questions that are now in the updated group
          const filteredContent = item.content?.filter((q) => {
            const lbl = (typeof q === "string" ? q : q?.label || "").trim()
            return lbl && !labelsInUpdatedGroup.has(lbl)
          })

          if (filteredContent && filteredContent.length > 0) {
            item.content = filteredContent
            return true
          }
          return false // Remove empty groups
        }
        return true
      })

      // Reassign orders to maintain sequence
      filteredItems.forEach((item, idx) => {
        item.orders = idx
      })

      return filteredItems
    })

    // Reset modal state
    handleCloseModal()
  }

  // Function to render question with collapsible options and option questions
  const renderQuestionWithCollapsibleOptions = (question, questionData, isGroupQuestion = false, groupIndex = null) => {
    const hasOptions = questionData?.options && questionData.options.length > 0
    const isPrimary = isGroupQuestion && question.isPrimary

    // Only show options for primary questions
    if (!isPrimary) {
      return (
        <div key={question.id || question.label} className="question-item">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <strong>{question.label}</strong>
            </div>
          </div>
        </div>
      )
    }

    const questionId = question.id || question.label

    return (
      <div key={questionId} className="question-item">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <strong>{question.label}</strong>
            <span className="badge bg-primary ms-2">Primary</span>
            {hasOptions && <span className="badge bg-info ms-2">{questionData.options.length} Options</span>}
          </div>
          <div className="d-flex align-items-center">
            {hasOptions && (
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary me-2"
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  togglePrimaryQuestionCollapse(questionId)
                }}
              >
                <i className={`fas fa-chevron-${!collapsedPrimaryQuestions[questionId] ? "up" : "down"}`}></i>
              </button>
            )}
          </div>
        </div>

        {/* Display options if they exist and question is not collapsed */}
        {hasOptions && !collapsedPrimaryQuestions[questionId] && (
          <div className="options-container ms-4 mt-2">
            <small className="text-muted">
              <i className="fas fa-list me-1"></i>
              Options:
            </small>
            {questionData.options.map((option, optionIndex) => {
              const hasOptionQuestions = option.option_questions && option.option_questions.length > 0
              const optionId = option.id || option.option_id

              return (
                <div key={optionId} className="option-item mt-1">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <small>
                        <strong>{option.option_name || option.label}</strong>
                        {hasOptionQuestions && (
                          <span className="badge bg-success ms-2">{option.option_questions.length} Questions</span>
                        )}
                      </small>
                    </div>
                    {hasOptionQuestions && (
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                          toggleOptionCollapse(optionId)
                        }}
                      >
                        <i className={`fas fa-chevron-${!collapsedOptions[optionId] ? "up" : "down"}`}></i>
                      </button>
                    )}
                  </div>

                  {/* Display option questions if they exist and option is not collapsed */}
                  {hasOptionQuestions && !collapsedOptions[optionId] && (
                    <div className="option-questions-container ms-4 mt-1">
                      <small className="text-muted">
                        <i className="fas fa-question-circle me-1"></i>
                        Sub-Questions:
                      </small>
                      {option.option_questions.map((subQuestion, subIndex) => (
                        <div key={subQuestion.id || subIndex} className="sub-question-item mt-1">
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <small>
                                <strong>{subQuestion.label}</strong>
                                <span className="text-muted ms-2">
                                  ({getQuestionTypeDisplayName(getInternalType(subQuestion.type))})
                                </span>
                              </small>
                            </div>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-secondary"
                              onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                toggleOptionQuestionsCollapse(`${optionId}-${subQuestion.id || subIndex}`)
                              }}
                            >
                              <i
                                className={`fas fa-chevron-${!collapsedOptionQuestions[`${optionId}-${subQuestion.id || subIndex}`] ? "up" : "down"}`}
                              ></i>
                            </button>
                          </div>

                          {/* Display option question details if not collapsed */}
                          {!collapsedOptionQuestions[`${optionId}-${subQuestion.id || subIndex}`] && (
                            <div className="option-question-details ms-4 mt-1">
                              <small className="text-muted">
                                <strong>Question Details:</strong>
                              </small>
                              <div className="mt-1">
                                <small>
                                  <strong>Type:</strong> {getQuestionTypeDisplayName(getInternalType(subQuestion.type))}
                                </small>
                                <br />
                                <small>
                                  <strong>Required:</strong> {subQuestion.isRequired ? "Yes" : "No"}
                                </small>
                                {subQuestion.isImportant && (
                                  <>
                                    <br />
                                    <small>
                                      <strong>Important:</strong> Yes
                                    </small>
                                  </>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        )}
      </div>
    )
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    // This function can be used for general form submission if needed
    // For now, we'll use the specific draft/publish handlers
  }

  const handleInputChange = (inputValue) => {
    setNewTag(inputValue)
  }

  const handleAddQuestion = () => {
    setShowQuestionDropdown(true)
    setShowAddButton(false)
  }

  const handleOtherQuestionChange = (selectedOptions) => {
    if (selectedOptions) {
      const selectedLabels = selectedOptions.map((option) => option.label)
      setOtherQuestions(selectedLabels)
    } else {
      setOtherQuestions([])
    }
  }

  const isPrimaryQuestionEligibleLocal = (questionLabel) => {
    const questionData = questionsData.find((q) => q.label === questionLabel)?.raw
    return isPrimaryQuestionEligible(questionData?.question_type)
  }

  const handlePrimaryQuestionChange = (questionInput) => {
    const questionLabel = typeof questionInput === "string" ? questionInput : questionInput.label || questionInput

    const questionData = questionsData.find((q) => q.label === questionLabel)
    if (questionData) {
      setPrimaryQuestion({ label: questionLabel })

      // Get options for the primary question
      const rawQuestionData = questionData.raw
      if (rawQuestionData?.options && rawQuestionData.options.length > 0) {
        setSelectedPrimaryOptions(rawQuestionData.options)
        setShowPrimaryOptions(true)
      } else {
        setSelectedPrimaryOptions([])
        setShowPrimaryOptions(false)
      }
    }
  }
  const optionMenu = [

    { value: "MENOPAUSE", label: "Menopause" },
    { value: "MALE", label: "Malechart" },
    { value: "GAPLD", label: "Gapld" },
  ]
  const allForms = ["MENOPAUSE", "MALE", "GAPLD"];

  const handleOnDeleteQuestion = (questionLabel) => {
    setOtherQuestions((prev) => prev.filter((q) => q !== questionLabel))

    // If this was the primary question, clear it
    if (primaryQuestion?.label === questionLabel) {
      setPrimaryQuestion(null)
      setSelectedPrimaryOptions([])
      setShowPrimaryOptions(false)
    }
  }

  const isPrimaryQuestionEligible = (questionType) => {
    return questionType === "single_choice" || questionType === "multiple_choice"
  }

  const handleCloseModal = () => {
    setShowModal(false)
    setEditingGroupIndex(null)
    setGroupName("")
    setPrimaryQuestion(null)
    setOtherQuestions([])
    setSelectedPrimaryOptions([])
    setOptionQuestionsMap({})
    setIsToggleOn(false)
    setOptionsCollapsed(false)
    setCollapsedOptions({})
    setShowPrimaryOptions(false)
    setShowOptionQuestionSelector(null)
  }

  const handleinSubmit = (e) => {
    e.preventDefault()

    if (!groupName.trim()) {
      alert("Please enter a group name")
      return
    }

    if (!primaryQuestion) {
      alert("Please select a primary question")
      return
    }

    const primaryRaw = questionsData.find((q) => q.label === primaryQuestion.label)?.raw

    const formattedOptions = selectedPrimaryOptions.map((opt) => {
      const optionId = (opt.option_id || opt.id || opt.optionId || "").toString()
      const optionObj = {
        id: optionId,
        label: opt.option_name || opt.label || opt.name,
      }

      const subQuestions =
        optionQuestionsMap[optionId] ||
        optionQuestionsMap[opt.option_id] ||
        optionQuestionsMap[opt.id] ||
        optionQuestionsMap[opt.optionId] ||
        []

      if (subQuestions.length > 0) {
        optionObj.option_questions = subQuestions.map((qLabel, idx) => {
          const raw = questionsData.find((q) => q.label === qLabel)?.raw
          return {
            id: raw?.question_id?.toString() || `q_${Date.now()}_${idx}`,
            label: raw?.question || qLabel,
            type: getInternalType(raw?.question_type) || "short_answer",
            order: idx + 1,
            isRequired: raw?.is_required === "Yes",
            isImportant: raw?.is_important === "Yes",
            is_primary: "Yes",
          }
        })
        optionObj.option_form = allForms.reduce((acc, val) => {
          acc[val] = (optionForms?.[optionId] || [])   // <-- use optionForms[optionId]
            .map((v) => v.toUpperCase())
            .includes(val)
            ? "Yes"
            : "No";
          return acc;
        }, {});

        console.log(
          "<==================================handleinsubmit==================================>",
          optionObj.label,       // option name/label
          optionId,
          optionForms?.[optionId],
          optionObj.option_form
        );

        // define for additional form
      }
      return optionObj
    })

    // Combine primary and other questions, ensuring no duplicates
    const filteredOtherQuestions = otherQuestions.filter((q) => q !== primaryQuestion.label)
    const updatedQuestions = [...(primaryQuestion ? [primaryQuestion.label] : []), ...filteredOtherQuestions]

    // Remove duplicates from the questions array
    const seen = new Set()
    const uniqueQuestions = updatedQuestions.filter((lbl) => {
      const trimmedLabel = lbl?.trim()
      if (!trimmedLabel || seen.has(trimmedLabel)) return false
      seen.add(trimmedLabel)
      return true
    })

    const groupStructure = uniqueQuestions.map((questionLabel, idx) => {
      if (questionLabel === primaryQuestion.label) {
        return {
          label: questionLabel,
          groupName: groupName,
          isPrimary: true,
          options: formattedOptions,
          isTab: isToggleOn,
          bg_color: selectedColor,
          sequence: idx + 1,
          groupId: `g${Date.now()}_${Math.random().toString(36).substr(2, 9)}`, // More unique ID
        }
      }
      return {
        label: questionLabel,
        groupName: groupName,
        isPrimary: false,
        isTab: isToggleOn,
        bg_color: selectedColor,
        sequence: idx + 1,
        groupId: `g${Date.now()}_${Math.random().toString(36).substr(2, 9)}`, // More unique ID
      }
    })

    // Add the new group to formItems with enhanced deduplication
    setFormItems((prev) => {
      const labelsInNewGroup = new Set(groupStructure.map((q) => q.label?.trim()).filter(Boolean))

      // Filter existing items to remove questions that will be in the new group
      const filteredExistingItems = prev.filter((item, idx) => {
        if (item.type === "single") {
          const label = (item.content?.label || item.content?.question || "").trim()
          return !labelsInNewGroup.has(label)
        }

        if (item.type === "group") {
          // Enhanced group filtering to prevent duplicates while preserving options
          const filteredContent = item.content?.filter((q) => {
            const lbl = (typeof q === "string" ? q : q?.label || "").trim()
            return lbl && !labelsInNewGroup.has(lbl)
          })

          if (filteredContent && filteredContent.length > 0) {
            // Preserve the group structure with filtered content
            return {
              ...item,
              content: filteredContent.map((q) => {
                if (typeof q === "string") return q
                return {
                  ...q,
                  options: q.options || [],
                  selectedOptions: q.selectedOptions || [],
                  optionQuestions: q.optionQuestions || {},
                  groupId: q.groupId || `g${idx}`,
                }
              }),
            }
          }
          return false // Remove empty groups
        }
        return true
      })

      // Add the new group
      const newFormItems = [
        ...filteredExistingItems,
        {
          type: "group",
          content: groupStructure,
          orders: filteredExistingItems.length,
        },
      ]

      // Final deduplication pass to ensure no duplicates
      const finalItems = []
      const processedGroupIds = new Set()

      newFormItems.forEach((item, idx) => {
        if (item.type === "group") {
          const groupId = item.content?.[0]?.groupId || `g${idx}`

          // Skip if group already processed
          if (processedGroupIds.has(groupId)) return
          processedGroupIds.add(groupId)

          // Ensure no duplicate questions within groups
          const uniqueContent = []
          const groupSeen = new Set()

          item.content?.forEach((q) => {
            const lbl = (typeof q === "string" ? q : q?.label || "").trim()
            if (lbl && !groupSeen.has(lbl)) {
              groupSeen.add(lbl)
              uniqueContent.push(q)
            }
          })

          if (uniqueContent.length > 0) {
            finalItems.push({
              ...item,
              content: uniqueContent,
              orders: finalItems.length,
            })
          }
        } else {
          finalItems.push({
            ...item,
            orders: finalItems.length,
          })
        }
      })

      return finalItems
    })

    // Reset modal state
    handleCloseModal()
  }

  const handleOtherQuestionOnChange = (selectedOptions, optionId) => {
    if (selectedOptions) {
      const selectedLabels = selectedOptions.map((option) => option.label)
      setOptionQuestionsMap((prev) => ({
        ...prev,
        [optionId]: selectedLabels,
      }))
    } else {
      setOptionQuestionsMap((prev) => ({
        ...prev,
        [optionId]: [],
      }))
    }
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              {loading ? (
                <Loader />
              ) : (
                <>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex align-items-center">
                      <h3 className="text-black font-w600 mb-0">
                        {isEditMode ? formData.title || "Edit Form" : "Create New Form"}
                      </h3>
                      {isPublished && (
                        <span className="badge bg-success ms-3">
                          <i className="fas fa-check-circle me-1"></i>
                          Published
                        </span>
                      )}
                    </div>
                    <RouterLink to="/forms" className="btn btn-link">
                      <Button variant="primary">Back</Button>
                    </RouterLink>
                  </div>
                  <form onSubmit={handleSubmit}>
                    <div className="row mb-2">
                      <div className="col-xl-4">
                        <div className="form-group mb-3">
                          <label className="form-label">
                            Form Title:<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            name="title"
                            className="form-control"
                            value={formData.title}
                            onChange={handleChange}
                            required
                          />
                          {formErrors.title && <div className="text-danger small mt-1">{formErrors.title}</div>}
                        </div>
                        <div className="form-group mb-3">
                          <label className="form-label">Image:</label>
                          <input type="file" className="form-control" accept="image/*" onChange={handleFileChange} />
                        </div>
                        {formData.image && (
                          <div>
                            <img
                              src={formData.image || "/placeholder.svg"}
                              alt="Preview"
                              style={{ width: "100%", height: "auto" }}
                            />
                          </div>
                        )}
                      </div>
                      <div className="col-xl-8">
  <div className="form-group position-relative">
    <label className="form-label">
      Description:<span style={{ color: "red" }}>*</span>
    </label>

    <textarea
      name="description"
      className="form-control pe-5"
      value={formData.description}
      onChange={handleChange}
      style={{ minHeight: "160px", paddingBottom: "40px" }}
      required
    />

    {/* 🎙 MIC */}
    <button
      type="button"
      onClick={startListening}
      disabled={isRecording}
      style={{
        position: "absolute",
        right: "10px",
        bottom: "10px",
        width: "34px",
        height: "34px",
        borderRadius: "50%",
        border: "none",
        background: isRecording ? "#ff4d4d" : "#f1f3f5",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: isRecording
          ? "0 0 10px 3px rgba(255,0,0,0.6)"
          : "0 2px 4px rgba(0,0,0,0.12)",
      }}
    >
      <FaMicrophone size={15} color={isRecording ? "white" : "#333"} />
    </button>

    {/* 🌐 Language toggle (optional) */}
    <button
      type="button"
      onClick={toggleLanguage}
      style={{
        position: "absolute",
        right: "55px",
        bottom: "10px",
        padding: "2px 10px",
        borderRadius: "12px",
        border: "1px solid #ccc",
        background: "#fff",
        fontSize: "12px",
      }}
    >
      {speechLang === "en-IN" ? "EN" : "MR"}
    </button>

    {formErrors.description && (
      <div className="text-danger small mt-1">
        {formErrors.description}
      </div>
    )}
  </div>
</div>

                    </div>
                    <div className="row mb-4">
                      <div className="col-xl-4">
                        <label className="form-label">Select Tags:</label>
                        <Select
                          name="tags"
                          options={filteredTags}
                          placeholder="Select or enter tags"
                          onInputChange={handleInputChange}
                          onChange={handleSelectChange}
                          inputValue={newTag}
                          // isMulti={true}
                          value={selectedTags}
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              minHeight: "50px",
                              height: "50px",
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              padding: "4px",
                            }),
                            indicatorSeparator: (provided) => ({
                              ...provided,
                              display: "none",
                            }),
                          }}
                        />
                      </div>
                      <div className="col-xl-1 d-flex align-items-end">
                        <button
                          type="button"
                          className="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center"
                          style={{ height: "50px" }}
                          onClick={handleAddTag}
                        >
                          Add
                        </button>
                      </div>
                    </div>

                    <div className="mt-3 d-flex flex-wrap mb-4">
                      {selectedTags.map((tag, idx) => (
                        <div
                          key={`${tag.value}-${idx}`}
                          className="badge bg-primary me-2 mb-2"
                          style={{
                            height: "40px",
                            padding: "0 15px",
                            fontSize: "16px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            cursor: "default",
                            backgroundColor: "#007bff",
                            color: "#fff",
                          }}
                        >
                          {tag.label}
                          <span
                            className="ms-2"
                            style={{
                              cursor: "pointer",
                              fontWeight: "bold",
                              fontSize: "20px",
                              marginLeft: "8px",
                              color: "#fff",
                            }}
                            onClick={() => handleRemoveTag(tag)}
                          >
                            &times;
                          </span>
                        </div>
                      ))}
                    </div>
                    <div className="row mb-3">
                      <div className="col-xl-4">
                        <label className="form-label">
                          Gender:<span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          value={
                            gender
                              ? {
                                value: gender,
                                label: gender.charAt(0).toUpperCase() + gender.slice(1),
                              }
                              : null
                          }
                          onChange={(selectedOption) => setGender(selectedOption?.value || "")}
                          options={[
                            { value: "male", label: "Male" },
                            { value: "female", label: "Female" },
                            { value: "transgender", label: "Transgender" },
                            { value: "all", label: "All" },
                          ]}
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              minHeight: "50px",
                              height: "50px",
                            }),
                            singleValue: (provided) => ({
                              ...provided,
                              lineHeight: "50px",
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              padding: "4px",
                            }),
                            indicatorSeparator: (provided) => ({
                              ...provided,
                              display: "none",
                            }),
                          }}
                        />
                        {formErrors.gender && <div className="text-danger small mt-1">{formErrors.gender}</div>}
                      </div>
                      <div className="col-xl-4">
                        <label className="form-label">Form For:</label>
                        <Select
                          value={
                            formData.form_for
                              ? {
                                value: formData.form_for,
                                label: formData.form_for.charAt(0).toUpperCase() + formData.form_for.slice(1),
                              }
                              : null
                          }
                          onChange={(selectedOption) =>
                            setFormData((prev) => ({
                              ...prev,
                              form_for: selectedOption.value,
                            }))
                          }
                          options={[
                            { value: "Panchkarma", label: "Panchkarma" },
                            { value: "General", label: "General" },
                            { value: "Patient", label: "Patient" },
                            { value: "Telecaller", label: "Telecaller" },
                            { value: "Service Caller", label: "Service Caller" },
                          ]}
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              minHeight: "50px",
                              height: "50px",
                            }),
                            singleValue: (provided) => ({
                              ...provided,
                              lineHeight: "50px",
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              padding: "4px",
                            }),
                            indicatorSeparator: () => ({
                              display: "none",
                            }),
                          }}
                        />
                      </div>

                      {formData.form_for === "Panchkarma" && (
                        <div className="col-xl-4">
                          <label className="form-label">Karma:</label>
                          <Select
                            value={formData.karma ? { value: formData.karma, label: formData.karma } : null}
                            onChange={(selectedOption) =>
                              setFormData((prev) => ({
                                ...prev,
                                karma: selectedOption.value,
                              }))
                            }
                            options={[
                              { value: "Good Karma", label: "Good Karma" },
                              { value: "Neutral Karma", label: "Neutral Karma" },
                              { value: "Bad Karma", label: "Bad Karma" },
                            ]}
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                minHeight: "50px",
                                height: "50px",
                              }),
                              singleValue: (provided) => ({
                                ...provided,
                                lineHeight: "50px",
                              }),
                              dropdownIndicator: (provided) => ({
                                ...provided,
                                padding: "4px",
                              }),
                              indicatorSeparator: () => ({
                                display: "none",
                              }),
                            }}
                          />
                        </div>
                      )}

                      <div className="row mb-3 mt-4">
                        <div className="col-xl-12">
                          <label className="form-label">Select Form Type:</label>
                          <Select
                            value={options1.find((option) => option.value === formData.formType)}
                            onChange={handleTypeChange}
                            options={options1}
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                minHeight: "50px",
                                height: "50px",
                              }),
                              singleValue: (provided) => ({
                                ...provided,
                                lineHeight: "50px",
                              }),
                              dropdownIndicator: (provided) => ({
                                ...provided,
                                padding: "4px",
                              }),
                              indicatorSeparator: (provided) => ({
                                ...provided,
                                display: "none",
                              }),
                            }}
                          />
                        </div>
                      </div>
                      {formData.formType === "disease" ||
                        (formData.formType === "Disease Form" && (
                          <div className="row mb-3">
                            <div className="col-xl-12">
                              <label className="form-label">Select Disease:</label>
                              <Select
                                options={(diseases || []).map((d) => ({
                                  value: d.disease_id.toString(),
                                  label: d.disease_name,
                                }))}
                                value={
                                  (diseases || [])
                                    .map((d) => ({
                                      value: d.disease_id.toString(),
                                      label: d.disease_name,
                                    }))
                                    .find((opt) => opt.value === formData.disease_id?.toString()) || null
                                }
                                onChange={handleDiseaseChange}
                                isClearable
                                placeholder="Choose a disease"
                              />
                              {formErrors.diseaseType && (
                                <div className="text-danger small mt-1">{formErrors.diseaseType}</div>
                              )}
                            </div>
                          </div>
                        ))}
                      {showQuestionDropdown && (
                        <div className="row mb-3">
                          <div className="col-xl-12">
                            <label className="form-label">Select Question:</label>
                            {loading ? (
                              <div>Loading questions...</div>
                            ) : (
                              <Select
                                onChange={handleQuestionChange}
                                options={questionsData}
                                styles={{
                                  control: (provided) => ({
                                    ...provided,
                                    minHeight: "50px",
                                    height: "50px",
                                  }),
                                  singleValue: (provided) => ({
                                    ...provided,
                                    lineHeight: "50px",
                                  }),
                                  dropdownIndicator: (provided) => ({
                                    ...provided,
                                    padding: "4px",
                                  }),
                                  indicatorSeparator: (provided) => ({
                                    ...provided,
                                    display: "none",
                                  }),
                                }}
                              />
                            )}
                          </div>
                        </div>
                      )}

                      <div className="row mb-3">
                        <div className="col-xl-12">
                          <button type="button" className="btn btn-info mt-2" onClick={handleAddQuestion}>
                            Add Questions
                          </button>
                          <Button type="button" className="btn btn-success mt-2 ms-2" onClick={handleAddGroup}>
                            Add Group
                          </Button>
                        </div>
                      </div>


                      {formErrors.questions && <div className="text-danger small mt-1">{formErrors.questions}</div>}

                      {/* Form Builder with HTML5 Drag and Drop - Unified Reordering */}
                      {/* <div className="alert alert-info mb-3">
                        <i className="fas fa-info-circle me-2"></i>
                        <strong>Drag & Drop:</strong> You can reorder questions and groups together in any order you want. 
                        The overall sequence of your form can be changed by dragging items to new positions.
                      </div> */}
                      {formItems.length > 0 && (
                        <div className="table-responsive">
                          {/* Main list container */}
                          <div id="question" className="dataTables_wrapper no-footer">
                            <table className="table table-striped lead-list mb-4 dataTablesCard fs-14 dataTable no-footer">
                              <thead>
                                <tr role="row">
                                  <th style={{ width: "50px" }}></th>
                                  <th>Questions</th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {/* Main list items (both questions and groups) - Unified ordering */}
                                {formItems.map((item, index) => (
                                  <tr
                                    key={
                                      item.type === "group" ? `group-${index}` : `single-${item.content.id || index}`
                                    }
                                    draggable={true}
                                    onDragStart={(e) => handleDragStart(e, item.type, index, null)}
                                    onDragOver={handleDragOver}
                                    onDrop={(e) => handleDropOriginal(e, item.type, index, null)}
                                    onDragLeave={handleDragLeave}
                                    style={{ cursor: "move" }}
                                  >
                                    <td style={{ width: "50px", textAlign: "center" }}>
                                      <i className="fa fa-bars" style={{ cursor: "move" }}></i>
                                    </td>
                                    <td>
                                      {item.type === "group" ? (
                                        <div style={{ paddingLeft: "8px" }}>
                                          {/* Group header */}
                                          <div className="d-flex justify-content-between align-items-center">
                                            <h5 className="mb-0">
                                              {item.content[0]?.groupName ||
                                                item.content[0]?.label ||
                                                `Question Group ${index + 1}`}
                                            </h5>
                                            <button
                                              className="btn"
                                              onClick={(e) => {
                                                e.preventDefault()
                                                e.stopPropagation()
                                                toggleCollapse(index)
                                              }}
                                              style={{
                                                background: "none",
                                                border: "none",
                                              }}
                                              type="button"
                                            >
                                              <i className={`fas fa-chevron-${!collapsed[index] ? "up" : "down"}`}></i>
                                            </button>
                                          </div>
                                          {/* Nested group content */}
                                          {!collapsed[index] && (
                                            <div
                                              style={{
                                                backgroundColor: item.content[0]?.bg_color || "#f8f9fa", // ✅
                                                padding: "8px",
                                                marginTop: "8px",
                                                borderRadius: "4px",
                                                minHeight: "50px",
                                              }}
                                            >
                                              {item.content.map((subQuestion, subIndex) => {
                                                const questionData = questionsData.find(
                                                  (q) =>
                                                    q.label ===
                                                    (typeof subQuestion === "string" ? subQuestion : subQuestion.label),
                                                )?.raw
                                                const isPrimary =
                                                  typeof subQuestion === "object" && subQuestion.isPrimary
                                                const hasOptions =
                                                  questionData?.options && questionData.options.length > 0

                                                return (
                                                  <div
                                                    key={`subQuestion-${index}-${subIndex}-${typeof subQuestion === "string" ? subQuestion : subQuestion.label}`}
                                                    style={{
                                                      padding: "8px",
                                                      margin: "4px 0",
                                                      backgroundColor: "transparent",
                                                      border: "1px solid #dee2e6",
                                                      borderRadius: "4px",
                                                    }}
                                                  >
                                                    {isPrimary && hasOptions ? (
                                                      renderQuestionWithCollapsibleOptions(
                                                        typeof subQuestion === "string"
                                                          ? { label: subQuestion }
                                                          : subQuestion,
                                                        questionData,
                                                        true,
                                                        index,
                                                      )
                                                    ) : (
                                                      <div className="d-flex justify-content-between align-items-center">
                                                        <div>
                                                          <strong>
                                                            {typeof subQuestion === "string"
                                                              ? subQuestion
                                                              : subQuestion.label}
                                                          </strong>
                                                          {isPrimary && (
                                                            <span className="badge bg-primary ms-2">Primary</span>
                                                          )}
                                                        </div>
                                                      </div>
                                                    )}
                                                  </div>
                                                )
                                              })}
                                            </div>
                                          )}
                                        </div>
                                      ) : (
                                        <div>
                                          {(() => {
                                            const questionData = questionsData.find(
                                              (q) => q.label === item.content.label,
                                            )?.raw
                                            // Standalone questions don't have options, so just display the question
                                            return <div>{item.content.label}</div>
                                          })()}
                                        </div>
                                      )}
                                    </td>
                                    <td>
                                      <div className="d-flex">
                                        {item.type === "group" && (
                                          <RouterLink
                                            href="#"
                                            className="edit me-2"
                                            onClick={() => handleEditGroup(index)}
                                            style={{
                                              cursor: "pointer",
                                            }}
                                          >
                                            <i className="fa fa-edit fs-18 text-primary"></i>
                                          </RouterLink>
                                        )}
                                        <RouterLink
                                          href="#"
                                          className="delete"
                                          onClick={() =>
                                            handleDeleteQuestion(
                                              item.type === "group" ? item.content : item.content.label,
                                            )
                                          }
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <i className="fa fa-trash fs-18 text-danger"></i>
                                        </RouterLink>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                      <div className="col-xl-12 d-flex justify-content-between">
                        <Tooltip
                          text={isEditMode ? "Preview form" : "Please save as draft first before preview"}
                          show={!isDraftSaved && !isEditMode}
                        >
                          <span style={{ display: "inline-block" }}>
                            <button
                              type="button"
                              className="btn btn-info"
                              onClick={handlePreview}
                              style={{
                                height: "50px",
                                minWidth: "120px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                pointerEvents: isDraftSaved || isEditMode ? "auto" : "none",
                                opacity: isDraftSaved || isEditMode ? 1 : 0.6,
                                cursor: isDraftSaved || isEditMode ? "pointer" : "not-allowed",
                              }}
                              disabled={submitting}
                            >
                              {submitting ? <Loader size="sm" /> : "Preview Form"}
                            </button>
                          </span>
                        </Tooltip>
                        <div className="d-flex gap-2">
                          <button
                            type="button"
                            className="btn"
                            style={{
                              backgroundColor: "orange",
                              color: "white",
                              height: "50px",
                              minWidth: "120px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            onClick={() => handleDraftOrPublish("draft")}
                            disabled={submitting}
                          >
                            {loadingButton === "draft" ? (
                              <Loader size="sm" />
                            ) : isEditMode || selectedFormId ? (
                              "Update Form"
                            ) : (
                              "Save as Draft"
                            )}
                          </button>
                          {!isPublished && (
                            <Tooltip
                              text={isEditMode ? "Publish form" : "Please save as draft first before publishing"}
                              show={!isDraftSaved && !isEditMode}
                            >
                              <span style={{ display: "inline-block" }}>
                                <button
                                  type="button"
                                  className="btn"
                                  onClick={handlePublishForm}
                                  style={{
                                    backgroundColor: "green",
                                    color: "white",
                                    height: "50px",
                                    minWidth: "120px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    pointerEvents: isDraftSaved || isEditMode ? "auto" : "none",
                                    opacity: isDraftSaved || isEditMode ? 1 : 0.6,
                                    cursor: isDraftSaved || isEditMode ? "pointer" : "not-allowed",
                                  }}
                                  disabled={submitting}
                                >
                                  {loadingButton === "published" ? <Loader size="sm" /> : "Publish"}
                                </button>
                              </span>
                            </Tooltip>
                          )}
                          {isPublished && (
                            <button
                              type="button"
                              className="btn"
                              onClick={handlePublishForm}
                              style={{
                                backgroundColor: "green",
                                color: "white",
                                height: "50px",
                                minWidth: "120px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              disabled={submitting}
                            >
                              {loadingButton === "published" ? <Loader size="sm" /> : "Republish"}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </form>

                  {/* Modal for Adding/Editing Group */}
                  <div
                    className={`modal fade ${showModal ? "show" : ""}`}
                    style={{
                      display: showModal ? "block" : "none",
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      zIndex: 9999,
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                    }}
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="addGroupModalLabel"
                    aria-hidden={!showModal}
                  >
                    <div className="modal-dialog modal-lg" role="document" style={{ zIndex: 10000 }}>
                      <div className="modal-content" style={{ zIndex: 10001, position: "relative" }}>
                        <div className="modal-header">
                          <h5 className="modal-title" id="addGroupModalLabel">
                            {editingGroupIndex !== null ? "Edit Group" : "Add Group"}
                          </h5>
                          <button
                            type="button"
                            className="btn-close btn-sm"
                            onClick={handleCloseModal}
                            aria-label="Close"
                          ></button>
                        </div>
                        <div className="modal-body" style={{ maxHeight: "80vh", overflowY: "auto" }}>
                          <form onSubmit={editingGroupIndex !== null ? handleUpdateGroup : handleinSubmit}>
                            <div className="mb-3">
                              <label htmlFor="groupName">Group Name</label>
                              <input
                                id="groupName"
                                type="text"
                                className="form-control"
                                placeholder="Enter group name"
                                value={groupName}
                                onChange={(e) => setGroupName(e.target.value)}
                              />
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <div className="me-3">
                                <span className="text-gray-700">Make as Tab:</span>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="flexSwitchCheckDefault"
                                  checked={isToggleOn}
                                  onChange={() => setIsToggleOn(!isToggleOn)}
                                />
                                <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
                                  {isToggleOn ? "On" : "Off"}
                                </label>
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <div className="me-3">
                                <span className="text-gray-700">Select Background Color:</span>
                              </div>

                              <input
                                type="color"
                                value={selectedColor}
                                onChange={(e) => setSelectedColor(e.target.value)}
                                style={{ width: "50px", height: "35px", cursor: "pointer", border: "none", background: "transparent" }}
                              />
                            </div>
                            <div className="mb-3">
                              <label htmlFor="otherQuestion">Select Questions</label>
                              <Select
                                id="otherQuestion"
                                value={questionsData.filter((option) => otherQuestions.includes(option.label))}
                                onChange={handleOtherQuestionChange}
                                options={questionsData}
                                isMulti
                                hideSelectedOptions={true}
                                isClearable={false}
                                styles={{
                                  control: (provided) => ({
                                    ...provided,
                                    minHeight: "50px",
                                    height: "50px",
                                  }),
                                  multiValue: (provided) => ({
                                    ...provided,
                                    display: "none",
                                  }),
                                  multiValueLabel: (provided) => ({
                                    ...provided,
                                    display: "none",
                                  }),
                                  multiValueRemove: (provided) => ({
                                    ...provided,
                                    display: "none",
                                  }),
                                  dropdownIndicator: (provided) => ({
                                    ...provided,
                                    padding: "4px",
                                  }),
                                  indicatorSeparator: (provided) => ({
                                    ...provided,
                                    display: "none",
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: 999999,
                                    position: "absolute",
                                    top: "auto",
                                    maxWidth: "100%",
                                  }),
                                  menuPortal: (provided) => ({
                                    ...provided,
                                    zIndex: 999999,
                                  }),
                                  menuList: (provided) => ({
                                    ...provided,
                                    zIndex: 999999,
                                  }),
                                  option: (provided) => ({
                                    ...provided,
                                    zIndex: 999999,
                                  }),
                                  container: (provided) => ({
                                    ...provided,
                                    zIndex: 999999,
                                  }),
                                }}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                menuPlacement="auto"
                                menuShouldScrollIntoView={true}
                                menuShouldBlockScroll={false}
                              />

                              {/* Questions Table with HTML5 Drag and Drop - Reordering Only */}
                              {/* <div className="alert alert-info mb-3">
                                <i className="fas fa-info-circle me-2"></i>
                                <strong>Drag & Drop:</strong> You can reorder questions within this list. Primary questions cannot be moved.
                              </div> */}
                              {otherQuestions.length > 0 && (
                                <div
                                  className="table-responsive mt-3"
                                  style={{ maxHeight: "300px", overflowY: "auto" }}
                                >
                                  <div id="otherQuestions" className="dataTables_wrapper no-footer">
                                    <table className="table table-striped lead-list mb-4 dataTablesCard fs-14 dataTable no-footer">
                                      <thead
                                        className="sticky-top"
                                        style={{
                                          backgroundColor: "white",
                                          zIndex: 1,
                                          borderBottom: "2px solid #dee2e6",
                                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                        }}
                                      >
                                        <tr role="row">
                                          <th style={{ width: "50px", padding: "12px 8px" }}></th>
                                          <th style={{ padding: "12px 8px" }}>Questions</th>
                                          <th style={{ padding: "12px 8px" }}>Type</th>
                                          <th style={{ width: "150px", padding: "12px 8px" }}>Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {otherQuestions.map((question, index) => {
                                          const questionData = questionsData.find((q) => q.label === question)?.raw
                                          const isEligibleForPrimary = isPrimaryQuestionEligibleLocal(question)
                                          const isPrimary = primaryQuestion?.label === question
                                          const hasOptions = questionData?.options && questionData.options.length > 0

                                          return (
                                            <tr
                                              key={question}
                                              draggable={true}
                                              onDragStart={(e) => handleModalDragStart(e, index)}
                                              onDragOver={handleDragOver}
                                              onDrop={(e) => handleModalDrop(e, index)}
                                              onDragLeave={handleDragLeave}
                                              style={{
                                                backgroundColor: "white",
                                                cursor: "move",
                                              }}
                                            >
                                              <td
                                                style={{
                                                  width: "50px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <i
                                                  className="fa fa-bars"
                                                  style={{
                                                    cursor: "move",
                                                    opacity: 1,
                                                  }}
                                                ></i>
                                              </td>
                                              <td>
                                                <div className="d-flex align-items-center">
                                                  <div className="flex-grow-1">
                                                    {question}
                                                    {isPrimary && (
                                                      <span className="badge bg-primary ms-2">Primary</span>
                                                    )}
                                                    {isPrimary && hasOptions && (
                                                      <span className="badge bg-info ms-2">
                                                        {questionData.options.length} Options
                                                      </span>
                                                    )}
                                                  </div>
                                                </div>
                                              </td>
                                              <td>
                                                {questionData?.question_type
                                                  ? getQuestionTypeDisplayName(
                                                    getInternalType(questionData.question_type),
                                                  )
                                                  : "N/A"}
                                                <div
                                                  className="ms-2"
                                                  style={{ position: "relative", display: "inline-block" }}
                                                  title={isEligibleForPrimary ? "Eligible for primary question" : ""}
                                                >
                                                  <img
                                                    src={icon2 || "/placeholder.svg"}
                                                    alt="Info"
                                                    className="ms-2"
                                                    style={{
                                                      width: "18px",
                                                      height: "18px",
                                                      cursor: "pointer",
                                                    }}
                                                  />
                                                </div>
                                              </td>
                                              <td
                                                style={{
                                                  textAlign: "center",
                                                }}
                                              >
                                                <div className="d-flex justify-content-center align-items-center">
                                                  {isEligibleForPrimary ? (
                                                    <Tooltip
                                                      text={isPrimary ? "Primary question" : "Make primary question"}
                                                    >
                                                      <input
                                                        type="radio"
                                                        name="primaryQuestion"
                                                        checked={isPrimary}
                                                        onChange={() => handlePrimaryQuestionChange(question)}
                                                        style={{
                                                          cursor: "pointer",
                                                          marginRight: "10px",
                                                        }}
                                                      />
                                                    </Tooltip>
                                                  ) : (
                                                    <Tooltip text="Only single selection or multiple selection questions can be primary">
                                                      <input
                                                        type="radio"
                                                        disabled
                                                        style={{
                                                          cursor: "not-allowed",
                                                          marginRight: "10px",
                                                          opacity: 0.5,
                                                        }}
                                                      />
                                                    </Tooltip>
                                                  )}
                                                  <RouterLink
                                                    to="#"
                                                    className="delete"
                                                    onClick={() => handleOnDeleteQuestion(question)}
                                                    style={{
                                                      cursor: "pointer",
                                                      marginLeft: "10px",
                                                    }}
                                                  >
                                                    <i className="fa fa-trash fs-18 text-danger"></i>
                                                  </RouterLink>
                                                </div>
                                              </td>
                                            </tr>
                                          )
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              )}
                            </div>
                            {primaryQuestion && (
                              <div className="mt-4">
                                <div
                                  onClick={toggleOptionsCollapse}
                                  style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    backgroundColor: "#f8f9fa",
                                    padding: "10px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  <h5 className="mb-0">
                                    <i className="fas fa-list me-2"></i>
                                    Options for Primary Question ({selectedPrimaryOptions.length} options)
                                  </h5>
                                  <i
                                    className={`fas fa-chevron-${!optionsCollapsed ? "up" : "down"}`}
                                    style={{ fontSize: "16px" }}
                                  ></i>
                                </div>
                                {!optionsCollapsed && selectedPrimaryOptions.length > 0 && (
                                  <div className="table-responsive mt-3">
                                    <table
                                      className="table table-striped lead-list mb-4 dataTablesCard fs-14 dataTable no-footer"
                                      style={{ border: "1px solid #dee2e6", borderRadius: "8px", overflow: "hidden" }}
                                    >
                                      <thead>
                                        <tr role="row" style={{ backgroundColor: "#495057", color: "white" }}>
                                          <th style={{ padding: "12px 8px" }}>Option Name</th>
                                          <th style={{ width: "200px", padding: "12px 8px" }}>Option Type</th>
                                          <th style={{ width: "200px", padding: "12px 8px" }}>Actions</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {selectedPrimaryOptions.map((option, index) => {
                                          // Handle both locally created and saved options
                                          const optionId = option.option_id || option.id
                                          const optionName = option.option_name || option.label
                                          const optionType = option.option_type || "N/A"
                                          const hasQuestions =
                                            optionQuestionsMap[optionId] && optionQuestionsMap[optionId].length > 0
                                          const isEven = index % 2 === 0

                                          return (
                                            <React.Fragment key={optionId}>
                                              <tr
                                                className="option-header-row"
                                                style={{
                                                  backgroundColor: isEven ? "#f8f9fa" : "#ffffff",
                                                  borderLeft: "4px solid #007bff",
                                                  borderBottom: "2px solid #e9ecef",
                                                }}
                                              >
                                                <td>
                                                  <div className="d-flex align-items-center">
                                                    <i
                                                      className="fas fa-circle me-2"
                                                      style={{ fontSize: "8px", color: "#007bff" }}
                                                    ></i>
                                                    <strong>{optionName}</strong>
                                                  </div>
                                                </td>
                                                <td>
                                                  <span className="badge bg-info">{optionType}</span>
                                                </td>
                                                <td>
                                                  <div className="d-flex gap-3">


                                                    <button
                                                      className="btn btn-xs btn-outline-primary"
                                                      onClick={() => {
                                                        setShowOptionQuestionSelector(
                                                          showOptionQuestionSelector === optionId ? null : optionId,
                                                        )
                                                      }}
                                                      type="button"
                                                    >
                                                      <i className="fas fa-plus me-1"></i>
                                                      Add Questions
                                                    </button>
                                                    {hasQuestions && (
                                                      <button
                                                        className="btn btn-xs btn-outline-secondary"
                                                        onClick={() => toggleModalOptionCollapse(optionId)}
                                                        type="button"
                                                        title={collapsedOptions[optionId] ? "Expand" : "Collapse"}
                                                      >
                                                        <i
                                                          className={`fas fa-chevron-${collapsedOptions[optionId] ? "down" : "up"}`}
                                                        ></i>
                                                      </button>
                                                    )}
                                                  </div>
                                                </td>
                                              </tr>
                                              {/* Conditional row for adding/editing questions for this option */}
                                              {showOptionQuestionSelector === optionId && (
                                                <tr>
                                                  <td colSpan="12">
                                                    <div
                                                      className="p-3 bg-light rounded"
                                                      style={{ border: "1px solid #dee2e6", margin: "8px 0" }}
                                                    >
                                                      {/* Label with close icon aligned to the right */}
                                                      <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <label
                                                          htmlFor={`option-questions-${optionId}`}
                                                          className="mb-0 fw-bold text-primary"
                                                        >
                                                          <i className="fas fa-question-circle me-2"></i>
                                                          Select Questions
                                                        </label>
                                                        {/* Close (cross) icon */}
                                                        <button
                                                          type="button"
                                                          className="btn btn-sm btn-light"
                                                          onClick={() => setShowOptionQuestionSelector(null)}
                                                          style={{ lineHeight: 1 }}
                                                        >
                                                          <i className="fa fa-times text-danger"></i>
                                                        </button>
                                                      </div>
                                                      {/* Select dropdown */}
                                                      <Select
                                                        id={`option-questions-${optionId}`}
                                                        value={questionsData.filter((q) =>
                                                          (optionQuestionsMap[optionId] || []).includes(q.label),
                                                        )}
                                                        onChange={(selected) =>
                                                          handleOtherQuestionOnChange(selected, optionId)
                                                        }
                                                        options={questionsData}
                                                        isMulti
                                                        hideSelectedOptions={true}
                                                        isClearable={true}
                                                        styles={{
                                                          control: (provided) => ({
                                                            ...provided,
                                                            minHeight: "50px",
                                                            height: "auto",
                                                          }),
                                                          dropdownIndicator: (provided) => ({
                                                            ...provided,
                                                            padding: "4px",
                                                          }),
                                                          indicatorSeparator: () => ({
                                                            display: "none",
                                                          }),
                                                          multiValue: () => ({
                                                            display: "none",
                                                          }),
                                                          multiValueLabel: () => ({
                                                            display: "none",
                                                          }),
                                                          multiValueRemove: () => ({
                                                            display: "none",
                                                          }),
                                                          menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 999999,
                                                            position: "absolute",
                                                            top: "auto",
                                                            left: "auto",
                                                            minWidth: "100%",
                                                          }),
                                                          menuPortal: (provided) => ({
                                                            ...provided,
                                                            zIndex: 999999,
                                                          }),
                                                          menuList: (provided) => ({
                                                            ...provided,
                                                            zIndex: 999999,
                                                          }),
                                                          option: (provided) => ({
                                                            ...provided,
                                                            zIndex: 999999,
                                                          }),
                                                          container: (provided) => ({
                                                            ...provided,
                                                            zIndex: 999999,
                                                          }),
                                                        }}
                                                        menuPortalTarget={document.body}
                                                        menuPosition="fixed"
                                                        menuPlacement="auto"
                                                        menuShouldScrollIntoView={true}
                                                        menuShouldBlockScroll={false}
                                                      />
                                                    </div>
                                                  </td>
                                                </tr>
                                              )}
                                              {/* Display selected questions for this option */}
                                              {optionQuestionsMap[optionId] &&
                                                optionQuestionsMap[optionId].length > 0 &&
                                                !collapsedOptions[optionId] && (
                                                  <tr>
                                                    <td colSpan="12">
                                                      {formData.form_for === "Patient" && (
                                                        <div style={{ marginTop: "10px", display: "flex", alignItems: "center" }}>
                                                          <label
                                                            htmlFor="optionForm"
                                                            style={{
                                                              fontWeight: "bold",
                                                              fontSize: "16px",
                                                              marginRight: "8px",
                                                              whiteSpace: "nowrap",
                                                            }}
                                                          >
                                                            Additional Form
                                                          </label>

                                                          <Select
                                                            inputId={`optionForm-${optionId}`}
                                                            options={optionMenu}
                                                            isMulti
                                                            placeholder="Select Additional Forms"
                                                            className="react-select-sm"
                                                            classNamePrefix="react-select"
                                                            value={
                                                              optionForms[optionId]
                                                                ? optionMenu.filter((opt) => optionForms[optionId].includes(opt.value))
                                                                : []
                                                            }
                                                            onChange={(selectedOptions) => {
                                                              const values = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
                                                              console.log("Saving additional forms for optionId", optionId, values);
                                                              setOptionForms((prev) => ({
                                                                ...prev,
                                                                [optionId]: values,
                                                              }));
                                                            }}

                                                            styles={{
                                                              control: (base) => ({
                                                                ...base,
                                                                minHeight: "45px",
                                                                fontSize: "15px",
                                                                width: "400px",
                                                                backgroundColor: "#fff",
                                                                borderColor: "#ccc",
                                                                boxShadow: "none",
                                                              }),
                                                              valueContainer: (base) => ({
                                                                ...base,
                                                                display: "flex",
                                                                flexWrap: "nowrap",
                                                                overflowX: "auto",
                                                                padding: "0 6px",
                                                              }),
                                                              multiValue: (base) => ({
                                                                ...base,
                                                                marginRight: "5px",
                                                              }),
                                                              indicatorsContainer: (base) => ({
                                                                ...base,
                                                                height: "45px",
                                                              }),
                                                              placeholder: (base) => ({
                                                                ...base,
                                                                color: "#999",
                                                                fontSize: "15px",
                                                              }),
                                                            }}
                                                          />

                                                        </div>
                                                      )}

                                                      <div
                                                        className="p-3 bg-white rounded"
                                                        style={{
                                                          border: "1px solid #e9ecef",
                                                          margin: "8px 0",
                                                          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                        }}
                                                      >

                                                        <div className="d-flex align-items-center mb-2">
                                                          <i className="fas fa-list-ul me-2 text-success"></i>
                                                          <strong className="text-success">
                                                            Questions ({optionQuestionsMap[optionId].length})
                                                          </strong>
                                                          <small className="text-muted ms-2">
                                                            <i className="fas fa-arrows-alt me-1"></i>
                                                            Drag to reorder
                                                          </small>
                                                        </div>
                                                        <table className="table table-sm table-hover mb-0">
                                                          <thead className="table-light">
                                                            <tr>
                                                              <th style={{ width: "80%" }}>Question</th>
                                                              <th style={{ width: "20%" }}>Actions</th>
                                                            </tr>
                                                          </thead>
                                                          <tbody>
                                                            {optionQuestionsMap[optionId].map((qLabel, qIdx) => (
                                                              <tr
                                                                key={`${optionId}-${qLabel}-${qIdx}`}
                                                                draggable={true}
                                                                onDragStart={(e) =>
                                                                  handleOptionQuestionDragStart(e, optionId, qIdx)
                                                                }
                                                                onDragOver={handleDragOver}
                                                                onDrop={(e) =>
                                                                  handleOptionQuestionDrop(e, optionId, qIdx)
                                                                }
                                                                onDragLeave={handleDragLeave}
                                                                style={{ cursor: "move" }}
                                                              >
                                                                <td>{qLabel}</td>
                                                                <td>
                                                                  <RouterLink
                                                                    className="delete"
                                                                    onClick={() => {
                                                                      setOptionQuestionsMap((prev) => ({
                                                                        ...prev,
                                                                        [optionId]: prev[optionId].filter(
                                                                          (item) => item !== qLabel,
                                                                        ),
                                                                      }))
                                                                    }}
                                                                    style={{
                                                                      cursor: "pointer",
                                                                      marginLeft: "10px",
                                                                    }}
                                                                  >
                                                                    <i className="fa fa-trash fs-18 text-danger"></i>
                                                                  </RouterLink>
                                                                </td>
                                                              </tr>
                                                            ))}
                                                          </tbody>
                                                        </table>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                )}
                                            </React.Fragment>
                                          )
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                              </div>
                            )}
                            <div className="modal-footer">
                              <Tooltip
                                text="Please select a primary question (single selection or multiple selection) for the group"
                                show={!primaryQuestion}
                              >
                                <span style={{ display: "inline-block" }}>
                                  <Button
                                    variant="primary"
                                    type="submit"
                                    className="mt-2"
                                    disabled={!primaryQuestion}
                                    tabIndex={primaryQuestion ? 0 : -1}
                                    style={{
                                      pointerEvents: primaryQuestion ? "auto" : "auto",
                                    }}
                                  >
                                    {editingGroupIndex !== null ? "Update" : "Submit"}
                                  </Button>
                                </span>
                              </Tooltip>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddForm;
